import React, { useState, useEffect, createRef } from 'react';
import ModalDescargaRecibo from '../../../components/modal/modal-descarga-recibo.jsx';
import CardContainer from '../../../components/card/card-container.jsx';
import Api from '../../../api/global.service';
import { subscribe, unsubscribe } from '../../../components/events';
import './entregas-x-productor.css';
import Swal from 'sweetalert2';
import Moment from 'moment';
import { useCoopConfig } from '../../../components/content/coop-config.jsx';
import ModalFirma from './modal-firma.jsx';
import { publish } from '../../../components/events.js';
import formatNumber from '../../../utils/formatNumber.js';
import BlockUi from 'react-block-ui';
import formatMoneyNumber from '../../../utils/formatNumber.js';

const EntregasXProductorFirmaXKilos = ({ data, cuenta, unit, montoPagado, precioXKg, kgs_a_pagar }) => {
  const [blocking, setBlocking] = useState(false);
  const dialog = createRef();
  const [imageURL, setImageURL] = useState(null);
  const [reciboPdfUrl, setReciboPdfUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const coopConfig = useCoopConfig();
  const handleFirma = event => {
    setImageURL(event.detail);
  };

  useEffect(() => {
    subscribe('Firma::onSave', e => handleFirma(e));
    return () => {
      unsubscribe('Firma::onSave');
    };
  }, []);

  const enviarDatos = () => {
    setBlocking(true);
    const formData = new FormData();
    formData.append('firma_image', imageURL);
    for (var key in data) {
      let v = data[key];
      if (v instanceof Date) {
        v = Moment(v).format('yyyy-MM-DD');
      } else if (v instanceof Array) {
        v = JSON.stringify(v);
      } else if (key === 'id_metodo_pago') {
        v = v.value;
      }
      formData.append(key, v);
    }
    formData.append('monto_pagado', montoPagado);
    formData.append('id_cuenta', cuenta.productor_id);
    formData.append('precio_x_kg', precioXKg);
    formData.append('kgs_a_pagar', kgs_a_pagar);

    Api.createMultiPart('admin/acopios/entregas/pago_pendiente_kilos', formData)
      .then(response => {
        let dataResponse = response?.data?.data;
        let uuid = dataResponse?.uuid_recibo;

        setBlocking(false);

        // Check if response has recibo_pdf
        if (uuid) {
          setReciboPdfUrl(`recibos/pagos/descargar/${uuid}`);
          setShowModal(true);
        } else {
          Swal.fire({
            icon: 'warning',
            title: '`No se registró el pago',
            text: `La información no ha sido registrada ni cambiada. Favor de contactar al equipo de Sirio para resolver el problema.`,
            allowOutsideClick: false,
          }).then(() => {
            window.location.href = `/admin/acopio/acopio_por_productor/list`;
          });
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log(e);
        setBlocking(false);
        Swal.fire({
          icon: 'error',
          title: '',
          text: e?.response?.data?.message,
        });
      });
  };

  const showForm = () => {
    publish('Entrega::onReturn');
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
      <CardContainer height={'100%'}>
        <ModalFirma ref={dialog} title="Generar firma" productor_nombre={cuenta?.productor_nombre} />

        {/* Modal for PDF Download */}
        {showModal && (
          <ModalDescargaRecibo
            reciboPdfUrl={reciboPdfUrl}
            onClick={() => {
              setShowModal(false);
              window.location.href = `/admin/acopio/acopio_por_productor/list`;
            }}
          />
        )}

        <div className="row">
          <div className="col-xl-8 col-lg-12 d-flex align-items-center">
            <span className="resumen-entrega-titulo">{'Resumen de pago pendiente'}</span>
          </div>
          <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
            <button
              className="text-green"
              onClick={() => showForm()}
              type="button"
              style={{
                border: 0,
                background: 'white',
                paddingLeft: 0,
                marginTop: 4,
                fontSize: '16px !important',
              }}>
              <i className="fa fa-arrow-left"></i> Volver a editar
            </button>
          </div>
        </div>

        <div className="pt-3">
          <div className="row">
            <div className="col-xl-12 resumen-entrega-subtitulo">{'Pago'}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{`Precio / ${unit}`}</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
              {coopConfig.currency()?.symbol + ' ' + formatMoneyNumber(data.precio_x_kg)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{`${unit} a pagar`}</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">{formatNumber(Number(data.kgs_a_pagar) || 0) + ' ' + unit}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{`Descuento de deudas`}</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
              {coopConfig.currency()?.symbol + ' ' + formatMoneyNumber(data.monto_descontar)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{'Monto pagado'}</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">
              {coopConfig.currency()?.symbol + ' ' + formatMoneyNumber(montoPagado)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-lg-6 resumen-entrega-elemento">{'Método de pago'}</div>
            <div className="col-xl-4 col-lg-6 resumen-entrega-valor">{data.id_metodo_pago.label || ''}</div>
          </div>
        </div>

        <div className="pt-3">
          <div className="row">
            <div className="col-xl-12 resumen-entrega-subtitulo pt-4">{'Firma de conformidad'}</div>
            <div className="col-xl-12 resumen-entrega-firma">
              <>
                {imageURL ? (
                  <img
                    src={imageURL}
                    alt="Firma generada"
                    style={{
                      display: 'block',
                      margin: '0 auto',
                      width: '224px',
                      height: '114px',
                    }}
                  />
                ) : null}
              </>
            </div>
            <p className="resumen-entrega-firmante">{cuenta?.productor_nombre}</p>
            <br />
          </div>
        </div>
        <button
          type="button"
          onClick={() => {
            dialog.current.show();
            setImageURL(null);
          }}
          style={{ marginTop: 0 }}
          className="btn btn-outline-secondary">
          Generar firma
        </button>

        <div className="row">
          <div className="col-xl-12 resumen-entrega-subtitulo pt-4">
            <button
              type="button"
              disabled={imageURL ? false : true}
              onClick={() => {
                enviarDatos();
              }}
              style={{ marginTop: 0 }}
              className="btn btn-outline-secondary btn-sirio">
              Guardar
            </button>
          </div>
        </div>
      </CardContainer>
    </BlockUi>
  );
};

export default EntregasXProductorFirmaXKilos;
